import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { IoMdSend } from "react-icons/io";
import { ToastContainer, toast } from "react-toastify";
import {
  acceptResale,
  bulkDeleteResale,
  bulkAcceptResale,
  deleteResale,
  getResales,
  searchResales,
} from "../../api/Resale";
import { useNavigate } from "react-router-dom";

const ResalesComponent = (props) => {
  const cookie = new Cookies();
  const navigate = useNavigate();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [loading, setLoading] = useState(true);
  const [resales, setResales] = useState(null);
  const [pageCount, setPageCount] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    cookie.get("resale_page") || 1,
  );
  const [searchValue, setSearchValue] = useState("");
  const [acceptId, setAcceptId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [idsSelected, setIdsSelected] = useState([]);

  const resalesGet = () => {
    setIdsSelected([]);
    if (searchValue && searchValue !== "") {
      searchResales(currentPage, props.pending, searchValue).then((result) => {
        setResales(result.data.response);
        setLoading(false);
        setPageCount(result.data.pageCount);
      });
    } else {
      getResales(currentPage, props.pending).then((result) => {
        setResales(result.data.response);
        setLoading(false);
        setPageCount(result.data.pageCount);
      });
    }
  };

  useEffect(() => {
    setResales(null);
    resalesGet();
  }, [currentPage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handlePageClick(1);
    resalesGet();
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("resale_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("resale_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleSelect = (id) => {
    if (idsSelected.includes(id)) {
      setIdsSelected(idsSelected.filter((item) => item !== id));
    } else {
      setIdsSelected([...idsSelected, id]);
    }
  };
  const handleSelectAll = () => {
    const allIds = resales.map((item) => item._id);

    if (idsSelected.length === allIds.length) {
      setIdsSelected([]); // unselect all
    } else {
      setIdsSelected(allIds); // select all
    }
  };

  const bulkDelete = () => {
    bulkDeleteResale(idsSelected).then((result) => {
      resalesGet();
      setIdsSelected([]);
    });
  };

  const bulkAccept = () => {
    bulkAcceptResale(idsSelected).then((result) => {
      resalesGet();
      setIdsSelected([]);
    });
  };

  return (
    <>
      {resales === null || loading ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            <form onSubmit={handleSubmit}>
              <div className="search-input-wrapper">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  placeholder="Resale name"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="search-input"
                />
                <button
                  type="submit"
                  className="password-toggle"
                  aria-label="Show password"
                >
                  <IoMdSend />
                </button>
              </div>
            </form>
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {renderPageNumbers()}
            <button
              onClick={handleNext}
              disabled={currentPage === pageCount}
              className="paginationButton"
            >
              Next
            </button>
          </div>

          {resales.length > 0 && (
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <label>
                <input
                  style={{ marginRight: "10px", marginTop: "10px" }}
                  type="checkbox"
                  checked={idsSelected.length === resales.length}
                  onChange={() => {
                    handleSelectAll();
                  }}
                  className="client-checkbox"
                />
                Select all users in this page
              </label>
              <div>
                {idsSelected.length > 0 && (
                <button
                  onClick={() => {
                    bulkDelete();
                  }}
                  className="action-btn remove-btn"
                >
                  Delete {idsSelected.length} resales
                </button>
              )}
              <span style={{padding: "10px"}}></span>
              {(idsSelected.length > 0 && props.pending) && (
                <button
                  onClick={() => {
                    bulkAccept();
                  }}
                  className="action-btn accept-btn"
                >
                  Accept {idsSelected.length} resales
                </button>
              )}
              </div>
            </div>
          )}
          <div className="card-cards">
            {resales?.length === 0 ? (
              <div>Not found</div>
            ) : (
              <>
                {resales?.map((resale) => (
                  <div
                    key={resale._id}
                    style={{ flexDirection: "row", display: "flex" }}
                  >
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={idsSelected.includes(resale?._id)}
                      onChange={() => {
                        handleSelect(resale._id);
                      }}
                      className="client-checkbox"
                    />
                    <div
                      key={resale._id}
                      className={`card-card ${resale.ban ? "banned" : ""}`}
                      style={{ width: "100%" }}
                    >
                      <div className="card-info">
                        <div>
                          <p className="line">
                            <span className="label">Resale name:</span>{" "}
                            {resale.adname}
                          </p>
                          <p className="line">
                            <span className="label">Upload by:</span>{" "}
                            {resale.user_id?.name}
                          </p>
                          <p className="line">
                            <span className="label">Created At:</span>{" "}
                            {resale.createdAt.slice(0, 10)}
                          </p>
                          {acceptId === resale._id && (
                            <div
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <p className="line">
                                Are you sure you want to accept this
                                resale?{" "}
                              </p>
                              <div className="card-info">
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      setAcceptId("");
                                    }}
                                    className="action-btn remove-btn"
                                  >
                                    No
                                  </button>
                                </div>
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      acceptResale(resale._id).then(
                                        (resullt) => {
                                          setAcceptId("");
                                          resalesGet();
                                        },
                                      );
                                    }}
                                    className="action-btn accept-btn"
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}

                          {deleteId === resale._id && (
                            <div
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                padding: "5px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <p className="line">
                                Are you sure you want to delete this
                                resale?{" "}
                              </p>
                              <div className="card-info">
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      setDeleteId("");
                                    }}
                                    className="action-btn accept-btn"
                                  >
                                    No
                                  </button>
                                </div>
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      deleteResale(resale._id).then(
                                        (resullt) => {
                                          setDeleteId("");
                                          resalesGet();
                                        },
                                      );
                                    }}
                                    className="action-btn remove-btn"
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {!acceptId && !deleteId && (
                        <div className="card-actions">
                          <button
                            onClick={() => {
                              navigate(`/resale/${resale._id}`);
                            }}
                            className="action-btn ban-btn"
                          >
                            {props.pending ? "View" : "Update"}
                          </button>
                          {props.pending && (
                            <button
                              onClick={() => {
                                setAcceptId(resale._id);
                              }}
                              className="action-btn accept-btn"
                            >
                              Accept
                            </button>
                          )}
                          <button
                            onClick={() => {
                              setDeleteId(resale._id);
                            }}
                            className="action-btn remove-btn"
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default ResalesComponent;
